var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleExclamation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 23,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  fill: "#FFAA1A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.66 14.3 10.12 9V5h3.1v4l-.52 5.3h-2.04Zm2.22 4.46c-.333.333-.733.5-1.2.5-.467 0-.867-.167-1.2-.5a1.637 1.637 0 0 1-.5-1.2c0-.467.167-.867.5-1.2.333-.333.733-.5 1.2-.5.467 0 .867.167 1.2.5.333.333.5.733.5 1.2 0 .467-.167.867-.5 1.2Z",
  fill: "#fff"
})));
export { SvgCircleExclamation as ReactComponent };
export default __webpack_public_path__ + "1b28787cfb379a131298eac7b9fdf811.svg";